import { render } from "./selfinfo.vue?vue&type=template&id=5a010832&scoped=true&ts=true"
import script from "./selfinfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./selfinfo.vue?vue&type=script&setup=true&lang=ts"

import "./selfinfo.vue?vue&type=style&index=0&id=5a010832&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a010832"],['__file',"src/views/me/selfinfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a010832"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a010832', __exports__)) {
    console.log('reload')
    api.reload('5a010832', __exports__)
  }
  
  module.hot.accept("./selfinfo.vue?vue&type=template&id=5a010832&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5a010832', render)
  })

}


export default __exports__